import { Component, ComponentRef,ViewChild,ViewContainerRef}   from '@angular/core';
import { AfterViewInit, OnInit, OnDestroy}          from '@angular/core';
import { OnChanges, SimpleChange, ComponentFactory} from '@angular/core';
import { DynamicData, ContentTypeBuilder } from './content-type-builder';
import { ContentTemplateBuilder } from './content-template-builder';
import { Router } from '@angular/router';
import { DataPasserService } from '../shared/data-passer.service';
import { DataPasser } from '../shared/data-passer';

@Component({
    selector: 'dps-manage-content',
    template: `<div #dpsTreeContentHolder></div>`
})
export default class DPSManageContent implements AfterViewInit, OnChanges, OnDestroy, OnInit {

    @ViewChild('dpsTreeContentHolder', {read: ViewContainerRef})
    protected dynamicComponentTarget: ViewContainerRef;
    protected componentRef: ComponentRef<DynamicData>;
    protected wasViewInitialized = false;
    private data: DataPasser = { entity_id: '', type: '', name: '', vcenter_instanceId: '', vcHost: ''};

    // @Input Can be used if required.
    // Add an Input called entity to all the candidate components
    protected entity = {};

    constructor (protected typeBuilder: ContentTypeBuilder,
                 protected templateBuilder: ContentTemplateBuilder,
                 public passer: DataPasserService ) {

        this.passer.getData().subscribe(data => {
            this.data = data;
            this.refreshContent();
        });
    }


    protected refreshContent() {

        if (this.componentRef) {
            this.componentRef.destroy();
        }

        let templateStr;

        if (this.data.type && this.data.type === 'resourcepool') {
            templateStr = 'dps-resource-pool-details-vc';
            this.entity = this.data;
        } else if (this.data.type && this.data.type === 'vm') {
            templateStr = 'dps-virtual-machine-details-vc';
            this.entity = this.data;
        } else if (this.data.type === 'datacenter' || this.data.type === 'cluster' || this.data.type === 'computeresource') {
            templateStr = 'dps-datacenter-details-vc';
            this.entity = this.data;
        } else {
            templateStr = 'default-page-details-vc';
        }

        let template = this.templateBuilder.prepareTemplate(templateStr, this.entity);

        this.typeBuilder
            .createComponentFactory(template)
            .then((factory: ComponentFactory<DynamicData>) =>
            {
                this.componentRef = this
                    .dynamicComponentTarget
                    .createComponent(factory);
                let component = this.componentRef.instance;

                component.entity = this.entity;
            });
    }

    public ngOnInit(): void {
    }

    public ngAfterViewInit(): void {
        this.wasViewInitialized = true;
        this.refreshContent();
    }

    public ngOnChanges(changes: {[key: string]: SimpleChange}): void {
        if (this.wasViewInitialized) {
            return;
        }
        this.refreshContent();
    }

    public ngOnDestroy() {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vc/manage/content-switcher/dps-manage-content.component.ts